import { Box, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { useColorScheme } from '@mui/material/styles';

export default function InitialLoading() {
    const { mode } = useColorScheme();

    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', width: '100%' }}
        >
            <motion.span
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ duration: 1, repeat: Infinity, repeatType: 'loop' }}
            >
                <Box
                    component="img"
                    src="/swonkie-logo.svg"
                    alt="Swonkie Logo"
                    width={70}
                    sx={{
                        filter: mode === 'dark' ? 'brightness(1.5)' : 'none',
                    }}
                />
            </motion.span>
        </Grid>
    );
}
